import { isProfileLoadedFromApi, checkNavItemAccess } from './featureFlagGuardUtils';

/**
 * Testable function for gallery route access.
 * Returns '/lms' to redirect, or undefined to allow access.
 */
export const checkGalleryAccess = (): string | undefined => {
   return checkNavItemAccess('image_gallery');
};

/**
 * Middleware to protect Gallery route when nav item is hidden.
 */
export default defineNuxtRouteMiddleware(() => {
   if (!isProfileLoadedFromApi()) {
      return;
   }

   const redirect = checkGalleryAccess();

   if (redirect) {
      return navigateTo(redirect);
   }
});
